<template>
  <div>
    <KTCard ref="preview" v-bind:title="'Edit'">
      <template v-slot:title>
        <h3 class="card-label">
          {{ $t("STOCK_RECEIVING_STORE") }}
        </h3>
      </template>
      <template v-slot:body>
        <b-row>
          <StockInfoPanels
            v-if="!firstLoader"
            :number="stockPurchaseOrder.id"
            :fromStoreName="stockPurchaseOrder.toStoreName"
            :toStoreName="stockPurchaseOrder.fromStoreName"
            :userName="stockPurchaseOrder.userName"
          >
          </StockInfoPanels>
          <b-col :sm="12">
            <StockPurchaseOrderRequestedItemsTable
              v-if="
                !firstLoader && _.size(stockPurchaseOrder.requestedItems) > 0
              "
              :headers="dynamicHeaders"
              :items="stockPurchaseOrder.requestedItems"
              :showTotalPrice="showTotalPrice"
              :action="action"
            >
            </StockPurchaseOrderRequestedItemsTable>
          </b-col>
        </b-row>
        <b-form>
          <SkeletonLoaderMain :visible="firstLoader"></SkeletonLoaderMain>
          <v-overlay :value="!firstLoader && isLoadingStock == true">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div
          v-show="_.size(errors) > 0"
          role="alert"
          class="alert alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>
        <BackButton></BackButton>
      </template>
      <template v-slot:toolbarfoot>
        <div class="example-tools justify-content-center">
          <SaveButton
            v-if="stockPurchaseOrder.statusId == 4"
            :isLoading="isLoadingStock"
            v-on:save="receiveStockPurchaseOrder($event)"
          ></SaveButton>
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  EXPORT_STOCK_REDIRECTING_XLS,
  FETCH_STOCK_PURCHASE_ORDER_RECEIVING
} from "@/modules/stock/store/stock.module";

import SaveButton from "@/view/content/forms/components/SaveButton.vue";

import StockInfoPanels from "@/modules/stock/components/StockInfoPanels.vue";

import StockPurchaseOrderRequestedItemsTable from "@/modules/stock/components/purchase-orders/StockPurchaseOrderRequestedItemsTable.vue";
import { RECEIVE_STOCK_PURCHASE_ORDER } from "@/modules/stock/store/stock.module";
import AuthService from "@/core/services/auth.service";

import KTCard from "@/view/content/Card.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "StockPurchaseOrderReceiving",
  mixins: [],
  data() {
    return {
      errors: {},
      action: "receiving",
      firstLoader: true,
      stockPurchaseOrder: {},
      showTotalPrice: false,
      startHeaders: [
        {
          text: this.$t("ITEM"),
          align: "start",
          filterable: true,
          value: "name"
        }
      ],
      endHeaders: []
    };
  },
  components: {
    KTCard,
    StockInfoPanels,
    StockPurchaseOrderRequestedItemsTable,
    SaveButton
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Stock purchase order receiving list",
        route: { name: "stock-purchase-orders-list-receiving" }
      }
    ]);

    vm.getStockPurchaseOrderReceiving();
  },
  computed: {
    ...mapGetters(["isLoadingStock", "currentUser"]),
    ...mapState({
      errors: (state) => state.auth.errors
    }),
    dynamicHeaders() {
      let vm = this;
      let dynamicHeaders = vm.startHeaders;

      let addHeaders = [
        {
          text: this.$t("STOCK_PURCHASE_ORDER_REQUESTED_UNIT_VALUE"),
          value: "unitValue",
          sortable: true
        },
        {
          text: this.$t("LOTS"),
          value: "poItems",
          sortable: true
        }
      ];
      //Add headers if needed between start and endheaders as it is in StockActionReview.vue

      dynamicHeaders = [...dynamicHeaders, ...addHeaders, ...vm.endHeaders];
      return dynamicHeaders;
    },
    selectedItems() {
      let vm = this;
      let requestedItems = vm.stockPurchaseOrder.requestedItems;
      const filteredData = requestedItems.flatMap((item) => {
        return item.poItems
          .filter((poItem) => poItem.unitValue > 0)
          .map((poItem) => {
            return {
              poItemId: poItem.id,
              receivedUnitValue: poItem.receivedUnitValue,
              returnedUnitValue: poItem.returnedUnitValue,
              missedUnitValue: poItem.missedUnitValue
            };
          });
      });
      return filteredData;
    },
    payload() {
      let vm = this;
      let payload = {};
      payload.stockPurchaseOrderId = vm.stockPurchaseOrder.id;
      payload.items = vm.selectedItems;
      return payload;
    }
  },
  methods: {
    getStockPurchaseOrderReceiving() {
      let vm = this;
      let id = this.$route.params.id;
      this.$store
        .dispatch(FETCH_STOCK_PURCHASE_ORDER_RECEIVING, id)
        .then((data) => {
          if (data.data.statusId != 4) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-purchase-orders-list-receiving" });
          } else {
            // vm.$notify({
            //   group: "notify",
            //   type: "success",
            //   title: "<i class='flaticon2-checkmark'></i> Success",
            //   text: data.message
            // });
            vm.firstLoader = false;
            vm.$nextTick(function () {
              vm.stockPurchaseOrder = data.data;
            });
          }
        })
        .catch((response) => {
          // if (response.status === 404) {
          vm.$notify({
            group: "notify",
            type: "error",
            text: response.data.message
          });
          this.$router.push({ name: "stock-purchase-orders-list-receiving" });
          // }
        });
    },
    receiveStockPurchaseOrder() {
      let vm = this;
      let message = vm.$t("PLEASE_CONFIRM");
      this.$dialog
        .confirm(message)
        .then(function () {
          let payload = vm.payload;
          vm.$store
            .dispatch(RECEIVE_STOCK_PURCHASE_ORDER, payload)
            .then((data) => {
              vm.errors = data.data.errors;
              vm.$notify({
                group: "notify",
                type: "success",
                title: "<i class='flaticon2-checkmark'></i> Success",
                text: data.message
              });
              vm.$nextTick(function () {
                vm.exportStockRedirectingXls(data.data.stockActionSent.id);
                AuthService.refreshUserData();
                vm.$router.push({
                  name: "stock-purchase-orders-list-receiving"
                });
              });
            })
            .catch(function (response) {
              vm.errors = response.data.errors;
              vm.$notify({
                group: "notify",
                type: "error",
                title: "Error",
                text: response.data.message
              });
              vm.getStockPurchaseOrderPrepare();
            });
        })
        .catch(function () {});
    },
    exportStockRedirectingXls(stockActionId) {
      let vm = this;
      let params = {
        stockActionId: stockActionId
      };
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(EXPORT_STOCK_REDIRECTING_XLS, apiParams)
        .then((data) => {
          vm.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          vm.firstLoader = false;
          vm.$nextTick(function () {
            let blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "stock-receiving-note-" + stockActionId;
            link.click();
            link.remove();
          });
        })
        .catch((response) => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
          }
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
